






import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import kepler from '../../../lib/kepler_sdk/kepler';
import Table from "@/views/UI/Table.vue";


@Component({
    components: {Table},
})
export default class People extends Vue {
    public items = []
    public endpoint = "drivers";
    public detail = "driver";


    public headers = [
        {text: 'ID', value: 'id', type: null},
        {text: 'DRIV', value: 'profile_picture', type: 'avatar' },
        {text: 'STATUS', value: 'status', type:null},
        {text: 'NAME', value: 'organization_name', type:null},
        //{text: 'CLIENT', value: 'main_driver.client_name', type:''},
        {text: 'CITY', value: 'address.city', type:null},
        {text: 'PHONE', value: 'phone', type:null},

    ]

    public options = {
        page: 1,
        itemsPerPage: 20
    }

    public loading = true


    public totalItems = null
    public totalPages = null

    // public handleClick(driver: any){
    //     this.$router.push({name: 'driver', params: { id: driver.id }})
    // }
    //
    // public mounted() {
    //     this.dataLoad()
    // }
    //
    // @Watch('options', {
    //     deep: true
    // })
    // private dataLoad() {
    //     this.loading = true
    //     kepler.get('drivers', this.options)!.then((d) => {
    //         this.totalItems = d.data.items_count
    //         this.totalPages = d.data.page_count
    //         this.items = d.data.items
    //         this.loading = false
    //     })
    // }
}
